import { gql } from '@apollo/client';

// ============================================================================
// QUERIES
// ============================================================================

export const CUENTAS_COBRO = gql`
  query CuentasCobro($periodo_mes: Int, $periodo_anio: Int, $estado: String, $busqueda: String, $limit: Int, $offset: Int) {
    cuentasCobro(periodo_mes: $periodo_mes, periodo_anio: $periodo_anio, estado: $estado, busqueda: $busqueda, limit: $limit, offset: $offset) {
      cuentas {
        id
        codigo
        ocupante_hospedaje_id
        nombre_soldado
        numero_documento
        grado_militar_nombre
        habitacion_numero
        cama_numero
        periodo_mes
        periodo_anio
        dias_periodo
        precio_noche
        monto_total
        monto_pagado
        saldo_pendiente
        estado
        fecha_emision
        fecha_pago_completo
      }
      total
    }
  }
`;

export const CUENTA_COBRO_DETALLE = gql`
  query CuentaCobro($id: Int!) {
    cuentaCobro(id: $id) {
      id
      codigo
      ocupante_hospedaje_id
      hospedaje_id
      nombre_soldado
      numero_documento
      tipo_documento
      grado_militar_nombre
      habitacion_numero
      cama_numero
      periodo_mes
      periodo_anio
      fecha_inicio_periodo
      fecha_fin_periodo
      dias_periodo
      precio_noche
      monto_total
      monto_pagado
      saldo_pendiente
      estado
      fecha_emision
      fecha_pago_completo
      notas
      pagos {
        id
        codigo
        monto
        metodo_pago
        referencia
        fecha_pago
        registrado_por_nombre
        notas
        anulado
        fecha_anulacion
        motivo_anulacion
      }
    }
  }
`;

export const RESUMEN_CUENTAS_COBRO = gql`
  query ResumenCuentasCobro($periodo_mes: Int!, $periodo_anio: Int!) {
    resumenCuentasCobro(periodo_mes: $periodo_mes, periodo_anio: $periodo_anio) {
      total_cuentas
      total_emitido
      total_cobrado
      total_pendiente
      porcentaje_cobro
      por_estado {
        emitidas
        parciales
        pagadas
        canceladas
      }
    }
  }
`;

export const OCUPANTES_ACTIVOS_PARA_CUENTAS = gql`
  query OcupantesActivosParaCuentas($periodo_mes: Int!, $periodo_anio: Int!) {
    ocupantesActivosParaCuentas(periodo_mes: $periodo_mes, periodo_anio: $periodo_anio) {
      id
      nombre
      numero_documento
      grado_nombre
      habitacion_numero
      cama_numero
      precio_noche
      hospedaje_id
      huesped_id
      monto_anticipo
      ya_tiene_cuenta
    }
  }
`;

export const ESTADO_CUENTA_SOLDADO = gql`
  query EstadoCuentaSoldado($ocupante_hospedaje_id: Int!) {
    estadoCuentaSoldado(ocupante_hospedaje_id: $ocupante_hospedaje_id) {
      ocupante {
        id
        nombre
        numero_documento
        tipo_documento
        grado_militar_nombre
        habitacion_numero
        cama_numero
        precio_noche
      }
      cuentas {
        id
        codigo
        periodo_mes
        periodo_anio
        dias_periodo
        monto_total
        monto_pagado
        saldo_pendiente
        estado
        fecha_emision
      }
      pagos {
        id
        codigo
        monto
        metodo_pago
        referencia
        fecha_pago
        notas
        anulado
        cuenta_codigo
        periodo_mes
        periodo_anio
      }
      total_facturado
      total_pagado
      saldo_total
    }
  }
`;

// ============================================================================
// MUTATIONS
// ============================================================================

export const GENERAR_CUENTAS_COBRO = gql`
  mutation GenerarCuentasCobro($input: GenerarCuentasCobroInput!) {
    generarCuentasCobro(input: $input) {
      cuentas_generadas
      cuentas {
        id
        codigo
        nombre_soldado
        monto_total
        estado
      }
    }
  }
`;

export const REGISTRAR_PAGO = gql`
  mutation RegistrarPagoCuentaCobro($input: RegistrarPagoCuentaCobroInput!) {
    registrarPagoCuentaCobro(input: $input) {
      pago {
        id
        codigo
        monto
        metodo_pago
      }
      cuenta {
        id
        monto_pagado
        saldo_pendiente
        estado
      }
    }
  }
`;

export const ANULAR_PAGO = gql`
  mutation AnularPagoCuentaCobro($pago_id: Int!, $motivo: String!) {
    anularPagoCuentaCobro(pago_id: $pago_id, motivo: $motivo) {
      id
      monto_pagado
      saldo_pendiente
      estado
    }
  }
`;

export const CANCELAR_CUENTA = gql`
  mutation CancelarCuentaCobro($id: Int!, $motivo: String) {
    cancelarCuentaCobro(id: $id, motivo: $motivo) {
      id
      estado
    }
  }
`;
